import styled from 'styled-components';

import { useSortable } from '@dnd-kit/react/sortable';

import Launcher from 'components/shared/Launcher';

import DragHandle from './DragHandle';
import type { CriteriaCategory } from './NewCategoryModal';

type Props = {
  category: CriteriaCategory;
  index: number;
  criteriaCount: number;
  onClick: () => void;
};

export default function CategoryCard({ category, index, criteriaCount, onClick }: Props) {
  const { ref, handleRef, isDragSource } = useSortable({
    id: category._tempId,
    index,
  });

  const subLabel = `${criteriaCount} Criteria`;

  return (
    <CardRow ref={ref} style={{ opacity: isDragSource ? 0.5 : 1 }}>
      <DragHandle ref={handleRef} />
      <LauncherWrapper>
        <Launcher label={category.name} subLabel={subLabel} handleLaunch={onClick} />
      </LauncherWrapper>
    </CardRow>
  );
}

const CardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LauncherWrapper = styled.div`
  flex: 1;
`;
